// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"321":"gs-messages.component","390":"gs-settings.component","491":"banner-notifications-controller","597":"notifications-message-component","894":"dashboard.component"}[chunkId] || chunkId) + ".js";
};